import React, { FC } from 'react'
import { HeaderWelcome } from './styled'

const WelcomeHeader: FC = () => {
	return (
		<HeaderWelcome>
			<HeaderWelcome.Inner />

			<HeaderWelcome.CatImg />

			<HeaderWelcome.LogoBox>
				<HeaderWelcome.Logo />
			</HeaderWelcome.LogoBox>
		</HeaderWelcome>
	)
}

export default WelcomeHeader
